<template>
  <div class="detail_other_message" >
    <div class="detail_other" v-for="item in productParams" :key="item.id">
      <span class="detail_title">{{ item.title }}：</span>
      <span class="detail_value">{{ item.value }}</span>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../../language/index'

export default {
  data(){return{}},
  props: {
    productParams: {
      type: Array,
      default: ()=>[]
    }
  }
};
</script>

<style scoped lang="scss">
.detail_other_message {
  margin-left: 15px;
  margin-top: 6px;
  transition: margin-left 0.5s;

  .detail_other {
    border-bottom: none !important;
    line-height: 40px;

    .detail_title {
      font-size: 14px;
      color: #666;
    }

    .detail_value {
      font-size: 14px;
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_detail/components/params.vue